import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import LoginPage from "@/pages/login/page";
import PinPage from "@/pages/pin/page";
import PosPage from "@/pages/pos/page";
import AuthCallbackPage from "@/pages/auth/callback/page";
import ResetPasswordPage from "@/pages/auth/reset-password/page";
import AdminLayout from "@/components/feature/AdminLayout";
import AdminDashboardPage from "@/pages/admin/dashboard/page";
import AdminUsersPage from "@/pages/admin/users/page";
import AdminBranchesPage from "@/pages/admin/branches/page";
import AdminSettingsPage from "@/pages/admin/settings/page";
import AdminProductsPage from "@/pages/admin/products/page";
import AdminInventoryPage from "@/pages/admin/inventory/page";
import AdminCustomersPage from "@/pages/admin/customers/page";
import AdminVehiclesPage from "@/pages/admin/vehicles/page";
import AdminServicesPage from "@/pages/admin/services/page";
import AdminOffersPage from "@/pages/admin/offers/page";
import AdminInvoicesPage from "@/pages/admin/invoices/page";
import AdminCashPage from "@/pages/admin/cash/page";
import AdminProfitsPage from "@/pages/admin/profits/page";
import AdminAuditPage from "@/pages/admin/audit/page";
import PublicCatalogPage from "@/pages/catalog/page";
import { GuestOnly, RequireAuth } from "@/components/feature/AuthGuard";
import RootRedirect from "@/components/feature/RootRedirect";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootRedirect />,
  },
  {
    path: "/login",
    element: (
      <GuestOnly>
        <LoginPage />
      </GuestOnly>
    ),
  },
  {
    path: "/pin",
    element: (
      <GuestOnly>
        <PinPage />
      </GuestOnly>
    ),
  },
  {
    path: "/catalogo",
    element: <PublicCatalogPage />,
  },
  {
    path: "/mapa-catalogo",
    element: <Navigate to="/catalogo" replace />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallbackPage />,
  },
  {
    path: "/auth/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/pos",
    element: (
      <RequireAuth>
        <PosPage />
      </RequireAuth>
    ),
  },
  {
    path: "/admin",
    element: (
      <RequireAuth role="admin">
        <AdminLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <AdminDashboardPage /> },
      { path: "users", element: <AdminUsersPage /> },
      { path: "branches", element: <AdminBranchesPage /> },
      { path: "settings", element: <AdminSettingsPage /> },
      { path: "products", element: <AdminProductsPage /> },
      { path: "inventory", element: <AdminInventoryPage /> },
      { path: "customers", element: <AdminCustomersPage /> },
      { path: "vehicles", element: <AdminVehiclesPage /> },
      { path: "services", element: <AdminServicesPage /> },
      { path: "offers", element: <AdminOffersPage /> },
      { path: "invoices", element: <AdminInvoicesPage /> },
      { path: "cash", element: <AdminCashPage /> },
      { path: "profits", element: <AdminProfitsPage /> },
      { path: "audit", element: <AdminAuditPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;